module.exports = __webpack_public_path__ + "img/day_trips-table-icon.ffccb8a2.svg";